import React from "react";
import "../../stylesheets/_home.scss";
import IntroImg from "../../Assets/images/intro_image.png";
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";

function IntroContainer() {
  return (
    <>
      <Helmet>
        <title>Phenom API Documentation |  List of Phenom API | Phenom Developer APIs</title>
        <meta name="description" content= "By leveraging the superpowers of artificial intelligence (AI), we are helping staffing agencies, HR Tech, and large employers thrive in a high-frequency workforce." />
      </Helmet>
      <div className="intro-container" data-testid="intro-container">
        <div className="intro-body">
          <div className="intro-info">
            <h2 className="intro-heading">
            Use <span className="company-name">Phenom API</span> to put the Talent
            Data to uses
            </h2>
            <p className=" intro-description">
            By leveraging the superpowers of artificial intelligence (AI), we
            are helping staffing agencies, HR Tech, and large employers thrive
            in a high-frequency workforce.
            </p>
            <div className="intro-action">
              <Link to='getStarted'>
                <div className="button">Get Started</div>
              </Link>
              <Link to='apiDetail'>
                <div className="button"> View Documentation</div>
              </Link>
            </div>
          </div>
          <div className="intro-image">
            <img src={IntroImg} alt=""></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default IntroContainer;
